// extracted by mini-css-extract-plugin
export default {"declarationItems":"Declaration_declarationItems__BBQft","stampText":"Declaration_stampText__ldrZQ"};